import deTranslations from "../../assets/locales/de/translation.json";
import enTranslations from "../../assets/locales/en/translation.json";
import frTranslations from "../../assets/locales/fr/translation.json";
import { getTypedValues } from "./functions/get-typed-values.function";

export const translationKeys: typeof deTranslations | typeof enTranslations | typeof frTranslations = getTypedValues(
  undefined,
  deTranslations,
);
